export const UPGRADING = 'UPGRADING';
export const RESTORING = 'RESTORING';
export const FAILED = 'FAILED';
export const RESTORE_FAILED = 'RESTORE_FAILED';
export const UPGRADED = 'UPGRADED';
export const RESTORED = 'RESTORED';
export const UPGRADE_FAILED = 'UPGRADE_FAILED';

export const MaintenanceUpgradeStatusList = [UPGRADING, RESTORING];
